var _circle, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8002,
    cy: 19.9573,
    r: 19.26,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1786 9.12402H15.4211C11.862 9.12402 8.96643 12.0197 8.96643 15.5789V24.3367C8.96643 27.8959 11.862 30.7915 15.4211 30.7915H24.1786C27.7377 30.7915 30.6333 27.8959 30.6333 24.3367V15.5789C30.6332 12.0197 27.7377 9.12402 24.1786 9.12402ZM28.4536 24.3367C28.4536 26.6977 26.5396 28.6118 24.1786 28.6118H15.4211C13.0601 28.6118 11.1461 26.6977 11.1461 24.3367V15.5789C11.1461 13.2178 13.0601 11.3038 15.4211 11.3038H24.1786C26.5396 11.3038 28.4536 13.2178 28.4536 15.5789V24.3367Z",
    fill: "url(#paint0_linear_709_2000)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8002 14.3535C16.7103 14.3535 14.1964 16.8675 14.1964 19.9575C14.1964 23.0475 16.7103 25.5615 19.8002 25.5615C22.8902 25.5615 25.404 23.0475 25.404 19.9575C25.404 16.8674 22.8902 14.3535 19.8002 14.3535ZM19.8002 23.3817C17.9091 23.3817 16.3761 21.8487 16.3761 19.9575C16.3761 18.0663 17.9092 16.5333 19.8002 16.5333C21.6913 16.5333 23.2244 18.0663 23.2244 19.9575C23.2244 21.8486 21.6913 23.3817 19.8002 23.3817Z",
    fill: "url(#paint1_linear_709_2000)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4137 15.7384C26.1553 15.7384 26.7565 15.1372 26.7565 14.3956C26.7565 13.6539 26.1553 13.0527 25.4137 13.0527C24.6721 13.0527 24.0709 13.6539 24.0709 14.3956C24.0709 15.1372 24.6721 15.7384 25.4137 15.7384Z",
    fill: "url(#paint2_linear_709_2000)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_709_2000",
    x1: 19.7999,
    y1: 30.7285,
    x2: 19.7999,
    y2: 9.29232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_709_2000",
    x1: 19.8002,
    y1: 30.7282,
    x2: 19.8002,
    y2: 9.29205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_709_2000",
    x1: 25.4137,
    y1: 30.7282,
    x2: 25.4137,
    y2: 9.29202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.04fdeb08ca7d5aed7a1350b7b1bfa3cc.svg";
export { ForwardRef as ReactComponent };